import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api/axios';
import { matchCsvBookboxName } from '../utils/matchBookBoxCsvName';
import './AdminAnalyze.css';

const AdminAnalyze = () => {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedBookBox, setSelectedBookBox] = useState('');

  // Bulk analyze state
  const [csvFile, setCsvFile] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkResults, setBulkResults] = useState([]);
  const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });
  const navigate = useNavigate();
  const location = useLocation();

  // BookBox list with colors
  const bookBoxList = [
    { name: 'AcryliPics', color: '#EFBF04' },
    { name: 'AOTA', color: '#FF8559' },
    { name: 'Allurial', color: '#000000' },
    { name: 'Aurora Crate', color: '#E0218A' },
    { name: 'Autumn Midnights', color: '#8F9F9A' },
    { name: 'Baddies', color: '#FF00FF' },
    { name: 'Bad Women Books', color: '#E89EB8' },
    { name: 'Merch with Indies', color: '#722F37' },
    { name: 'Bewitched Pages', color: '#06402B' },
    { name: 'Belle', color: '#8E5A6A' },
    { name: 'Beyond the Pages', color: '#2F5F55' },
    { name: 'Book in a Box', color: '#cf597d' },
    { name: 'Bookish & Spice', color: '#8E5A6A' },
    { name: 'BFDC', color: '#878686' },
    { name: 'C2C', color: '#8897a6' },
    { name: 'Coveted Cover', color: '#78C7C7' },
    { name: 'Dainty', color: '#ffe3e3' },
    { name: 'Dark & Disturbed', color: '#323232' },
    { name: 'Blackout Romance', color: '#1e1e1e' },
    { name: 'Motley Chronicles', color: '#510466' },
    { name: 'Dark and Nerdy', color: '#0494b8' },
    { name: 'Dark & Quirky', color: '#eaeaea' },
    { name: 'Endless Pages', color: '#323232' },
    { name: 'Eternal Embers', color: '#6b6570' },
    { name: 'Euphoric Lit', color: '#282828' },
    { name: 'Everheart', color: '#c486b5' },
    { name: 'Fae Crate', color: '#7d1799' },
    { name: 'Fairyloot', color: '#483773' },
    { name: 'Fated Romance', color: '#6b91e3' },
    { name: 'Final Score', color: '#1F405F' },
    { name: 'Foxglove', color: '#F1C3B7' },
    { name: 'Fox & Wit', color: '#E3BE3C' },
    { name: 'Haunted Hearts', color: '#740503' },
    { name: 'Hello Lovely', color: '#7DBFE6' },
    { name: 'Hidden Secrets Bookstore', color: '#3B3B3B' },
    { name: 'Illumicrate', color: '#FDDD57' },
    { name: 'Afterlight', color: '#FFE8A3' },
    { name: 'Starbright', color: '#FFEE58' },
    { name: 'Evernight', color: '#E3B400' },
    { name: 'Mindsight', color: '#FFC94A' },
    { name: 'Lavish Library', color: '#C9C5B9' },
    { name: 'La Petite Mort', color: '#8C0000' },
    { name: 'Lilac Library\'s', color: '#C3B4D0' },
    { name: 'Lit Haven', color: '#D2D2D1' },
    { name: 'LitJoy', color: '#454545' },
    { name: 'Little Wicked', color: '#BFE9D6' },
    { name: 'Luna & Lore', color: '#196E92' },
    { name: 'Lunarya', color: '#9560A1' },
    { name: 'Midnight Whispers', color: '#1B1030' },
    { name: 'Roses & Thorns', color: '#B28AAA' },
    { name: 'Phoenix', color: '#CC4A00' },
    { name: 'Moonbowbookclub', color: '#3E7ACB' },
    { name: 'Moonlight', color: '#4C235E' },
    { name: 'Mystic Box', color: '#390706' },
    { name: 'Nocturnal Ink Book Co', color: '#b08d57' },
    { name: 'Obsidian Descension', color: '#77274D' },
    { name: 'OwlCrate', color: '#1D1432' },
    { name: 'Page and Wick', color: '#00273A' },
    { name: 'PXC', color: '#bf9000' },
    { name: 'Red Flags & Roses', color: '#6C0200' },
    { name: 'RIP', color: '#C7FF00' },
    { name: 'Renegade Romance', color: '#E8567B' },
    { name: 'Romance Cartel', color: '#D57A93' },
    { name: 'Romance Era', color: '#A3386C' },
    { name: 'Romance Reveal', color: '#F50C72' },
    { name: 'Shades of Desire Books & Co.', color: '#2C2D31' },
    { name: 'Sinful Obsessions', color: '#332828' },
    { name: 'Smut & Sip', color: '#870022' },
    { name: 'Sonny', color: '#704745' },
    { name: 'Spiced', color: '#EEE0D6' },
    { name: 'Arcane Society', color: '#B9A191' },
    { name: 'Book Cove ZA', color: '#6E438A' },
    { name: 'Bookaholic', color: '#D7A75C' },
    { name: 'Bookish Box', color: '#0B2C04' },
    { name: 'Bound Collector', color: '#9B6B4E' },
    { name: 'Brightside Candles', color: '#500011' },
    { name: 'Broken Binding', color: '#0B6F36' },
    { name: 'Butterfly Book Club', color: '#F4CCCD' },
    { name: 'Ink Pages', color: '#1A3A2C' },
    { name: 'Last Chapter', color: '#FAF5F8' },
    { name: 'Locked Library', color: '#FC038A' },
    { name: 'Lovely Story Society', color: '#7C6A66' },
    { name: 'Midnight Bookshelf', color: '#9FA9F8' },
    { name: 'TPLW', color: '#CCAC00' },
    { name: 'Quill & Quiver', color: '#7F451D' },
    { name: 'Twisted Fiction', color: '#BF00FF' },
    { name: 'Twisted Retreat', color: '#595959' },
    { name: 'Unplugged', color: '#63b999' },
    { name: 'Wolfsbane', color: '#1D3948' },
  ];

  // Helper function to determine if text should be light or dark based on background color
  const getTextColor = (hexColor) => {
    // Convert hex to RGB
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black text for light backgrounds, white for dark
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  };

  // ─── CSV parsing helpers ────────────────────────────────────────────────────

  const parseCSVRow = (row) => {
    const result = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < row.length; i++) {
      const ch = row[i];
      if (ch === '"') {
        if (inQuotes && row[i + 1] === '"') { current += '"'; i++; }
        else inQuotes = !inQuotes;
      } else if (ch === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += ch;
      }
    }
    result.push(current);
    return result;
  };

  const parseCSVText = (csvText) => {
    // Split into logical rows respecting quoted multiline fields.
    // A bare split('\n') breaks quoted cells that contain newlines,
    // causing text content to bleed into the bookbox-name column.
    const logicalRows = [];
    let rowBuffer = '';
    let inQuotes = false;
    for (let i = 0; i < csvText.length; i++) {
      const ch = csvText[i];
      if (ch === '"') {
        if (inQuotes && csvText[i + 1] === '"') { rowBuffer += '""'; i++; }
        else { inQuotes = !inQuotes; rowBuffer += ch; }
      } else if ((ch === '\n' || ch === '\r') && !inQuotes) {
        if (rowBuffer.trim()) logicalRows.push(rowBuffer);
        rowBuffer = '';
        if (ch === '\r' && csvText[i + 1] === '\n') i++;
      } else {
        rowBuffer += ch;
      }
    }
    if (rowBuffer.trim()) logicalRows.push(rowBuffer);

    if (logicalRows.length < 2) return [];
    const headers = parseCSVRow(logicalRows[0]).map(h => h.trim().toLowerCase().replace(/^"|"$/g, ''));
    const bookboxIdx  = headers.findIndex(h => h.includes('bookbox') || h === 'book box' || h === 'bookbox name');
    const textIdx     = headers.findIndex(h => h === 'text');
    const linkIdx     = headers.findIndex(h => h === 'link');
    const imgLinkIdx  = headers.findIndex(h => h === 'img_link' || h === 'imglink' || h === 'img link' || h === 'img_url' || h === 'img url');
    const rows = [];
    for (let i = 1; i < logicalRows.length; i++) {
      const cols = parseCSVRow(logicalRows[i]).map(c => c.trim().replace(/^"|"$/g, ''));
      const bookboxName = bookboxIdx  >= 0 ? (cols[bookboxIdx]  || '').trim() : '';
      const rowText     = textIdx     >= 0 ? (cols[textIdx]     || '').trim() : '';
      const rowLink     = linkIdx     >= 0 ? (cols[linkIdx]     || '').trim() : '';
      const rowImgLink  = imgLinkIdx  >= 0 ? (cols[imgLinkIdx]  || '').trim() : '';
      if (bookboxName || rowText) rows.push({ bookboxName, text: rowText, link: rowLink, imgLink: rowImgLink });
    }
    return rows;
  };

  // ─── Date / time converters (mirrors AdminForm logic) ─────────────────────

  const parseHumanReadableDate = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return '';
    const trimmed = dateString.trim();
    if (!trimmed || trimmed.toLowerCase() === 'n/a') return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
    const monthNames = {
      january:0,jan:0,february:1,feb:1,march:2,mar:2,april:3,apr:3,
      may:4,june:5,jun:5,july:6,jul:6,august:7,aug:7,
      september:8,sep:8,sept:8,october:9,oct:9,november:10,nov:10,december:11,dec:11
    };
    const m = trimmed.match(/(\w+)\s+(\d{1,2})(?:st|nd|rd|th)?(?:\s*,?\s*(\d{4}))?/i);
    if (m) {
      const mn = m[1].toLowerCase();
      const day = parseInt(m[2], 10);
      const year = m[3] ? parseInt(m[3], 10) : new Date().getFullYear();
      if (monthNames[mn] !== undefined && day >= 1 && day <= 31) {
        const month = monthNames[mn];
        try {
          const d = new Date(year, month, day);
          if (d.getFullYear() === year && d.getMonth() === month && d.getDate() === day)
            return `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
        } catch(e) {}
      }
    }
    try {
      const parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) {
        return `${parsed.getFullYear()}-${String(parsed.getMonth()+1).padStart(2,'0')}-${String(parsed.getDate()).padStart(2,'0')}`;
      }
    } catch(e) {}
    return '';
  };

  const extractDateFromDateTime = (s) => {
    if (!s) return '';
    if (s.includes('T')) return s.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    return '';
  };

  const extractTimeFromDateTime = (s) => {
    if (!s) return '';
    if (s.includes('T')) {
      const tp = s.split('T')[1];
      if (tp) { const m = tp.match(/^(\d{2}):(\d{2})/); if (m) return `${m[1]}:${m[2]}`; }
    }
    return '';
  };

  const convertToTimeFormat = (timeString) => {
    if (!timeString) return '';
    if (typeof timeString !== 'string') timeString = String(timeString);
    const trimmed = timeString.trim();
    if (!trimmed) return '';
    let clean = trimmed.replace(/\s*(est|gmt|utc|pst|pdt|edt|cdt|mdt|mst)\s*/gi, '').trim();
    const withMin = clean.match(/(\d{1,2})\s*:\s*(\d{1,2})\s*(am|pm|a\.m\.|p\.m\.)/i);
    const noMin   = clean.match(/(\d{1,2})\s+(am|pm|a\.m\.|p\.m\.)/i) || clean.match(/(\d{1,2})(am|pm|a\.m\.|p\.m\.)/i);
    if (withMin) {
      let h = parseInt(withMin[1],10), min = parseInt(withMin[2],10);
      const ap = withMin[3].toLowerCase().replace(/\./g,'');
      if (h<1||h>12||min<0||min>59) return '';
      if (ap==='pm'&&h!==12) h+=12; else if (ap==='am'&&h===12) h=0;
      return `${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}`;
    } else if (noMin) {
      let h = parseInt(noMin[1],10);
      const ap = noMin[2].toLowerCase().replace(/\./g,'');
      if (h<1||h>12) return '';
      if (ap==='pm'&&h!==12) h+=12; else if (ap==='am'&&h===12) h=0;
      return `${h.toString().padStart(2,'0')}:00`;
    }
    const hhmm = clean.match(/^(\d{1,2}):(\d{1,2})(?::\d{1,2})?$/);
    if (hhmm) {
      const h = parseInt(hhmm[1],10), min = parseInt(hhmm[2],10);
      if (h>=0&&h<=23&&min>=0&&min<=59) return `${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}`;
    }
    const justH = clean.match(/^(\d{1,2})$/);
    if (justH) { const h = parseInt(justH[1],10); if (h>=0&&h<=23) return `${h.toString().padStart(2,'0')}:00`; }
    return '';
  };

  const convertAnalyzeToFormData = (data, linkToPost, coverImageUrl) => {
    let price = data.price || '';
    if (price.trim() && !price.trim().endsWith(' + shipping')) price = price.trim() + ' + shipping';
    return {
      bookName:  data.bookName  || '',
      price,
      bookBox:   data.bookBox   || '',
      author:    data.author    || '',
      linkToPost: linkToPost    || '',
      coverImageUrl: coverImageUrl || '',
      shipmentDate: data.shipmentDate || '',
      firstAccessDate:
        parseHumanReadableDate(data.firstAccessDate) ||
        parseHumanReadableDate(data.firstAccessDateUKINT) ||
        parseHumanReadableDate(data.firstAccessDateUSCanada) ||
        extractDateFromDateTime(data.firstAccessDateTime) || '',
      firstAccessTimeUKINT:     convertToTimeFormat(data.firstAccessTimeUKINT)     || '',
      firstAccessTimeUSCanada:  convertToTimeFormat(data.firstAccessTimeUSCanada)  || '',
      firstAccessTimeLocalRegional: convertToTimeFormat(data.firstAccessTimeLocalRegional) || '',
      earlyAccessDate:
        parseHumanReadableDate(data.earlyAccessDate) ||
        parseHumanReadableDate(data.earlyAccessDateUKINT) ||
        parseHumanReadableDate(data.earlyAccessDateUSCanada) ||
        extractDateFromDateTime(data.earlyAccessDateTime) || '',
      earlyAccessDateTimeUKINT:     convertToTimeFormat(data.earlyAccessDateTimeUKINT)     || '',
      earlyAccessDateTimeUSCanada:  convertToTimeFormat(data.earlyAccessDateTimeUSCanada)  || '',
      activeSubscribersTimeLocalRegional: convertToTimeFormat(data.activeSubscribersTimeLocalRegional) || '',
      publicAccessDate:
        parseHumanReadableDate(data.publicAccessDate) ||
        parseHumanReadableDate(data.publicAccessDateUKINT) ||
        parseHumanReadableDate(data.publicAccessDateUSCanada) ||
        extractDateFromDateTime(data.publicAccessDateTime) || '',
      publicAccessTimeUKINT:     convertToTimeFormat(data.publicAccessTimeUKINT)     || '',
      publicAccessTimeUSCanada:  convertToTimeFormat(data.publicAccessTimeUSCanada)  || '',
      publicAccessTimeLocalRegional: convertToTimeFormat(data.publicAccessTimeLocalRegional) || '',
      openPreorderDate:
        parseHumanReadableDate(data.openPreorderDate) ||
        extractDateFromDateTime(data.openPreorderDateTime) || '',
      openPreorderTime:
        extractTimeFromDateTime(data.openPreorderDateTime) || convertToTimeFormat(data.openPreorderTime) || '',
      preorderCloseDate:
        parseHumanReadableDate(data.preorderCloseDate) ||
        extractDateFromDateTime(data.preorderCloseDateTime) || '',
      preorderCloseTime:
        extractTimeFromDateTime(data.preorderCloseDateTime) || convertToTimeFormat(data.preorderCloseTime) || '',
      membersOnlyDate:
        parseHumanReadableDate(data.membersOnlyDate) ||
        extractDateFromDateTime(data.membersOnlyDateTime) || '',
      membersOnlyTime:
        extractTimeFromDateTime(data.membersOnlyDateTime) || convertToTimeFormat(data.membersOnlyTime) || '',
    };
  };

  // If post is sale-only (no first/early/general/public-access tier language),
  // remap single public sale window into Open Preorder fields.
  const remapSaleOnlyToOpenPreorder = (formFields, rowText) => {
    const text = String(rowText || '').toLowerCase();
    const hasTierLanguage =
      /\b(first\s+access|early\s+access|general\s+access|public\s+access|public\s+sale|subscriber\s+access)\b/i.test(text) ||
      /\buk\s*:\s*general\s+sale\b/i.test(text) ||
      /\bus\s*:\s*general\s+sale\b/i.test(text) ||
      /\buk\/int\b/i.test(text) ||
      /\bus\/canada\b/i.test(text);
    if (hasTierLanguage) return formFields;

    const hasOpenDate = !!String(formFields.openPreorderDate || '').trim();
    const hasOpenTime = !!String(formFields.openPreorderTime || '').trim();
    if (hasOpenDate && hasOpenTime) return formFields;

    const pubDate = String(formFields.publicAccessDate || '').trim();
    const pubTime = String(formFields.publicAccessTimeLocalRegional || '').trim();
    if (!pubDate || !pubTime) return formFields;

    return {
      ...formFields,
      openPreorderDate: pubDate,
      openPreorderTime: pubTime,
      publicAccessDate: '',
      publicAccessTimeLocalRegional: '',
      publicAccessTimeUKINT: '',
      publicAccessTimeUSCanada: '',
    };
  };

  // If both First Access and General Access are explicitly present in text,
  // keep only those two windows and drop inferred/pre-fallback tiers.
  const enforceFirstAndGeneralOnlyWhenExplicit = (formFields, rowText) => {
    const text = String(rowText || '').toLowerCase();
    const hasExplicitFirst = /\bfirst\s+access\b/i.test(text);
    const hasExplicitGeneral = /\bgeneral\s+access\b/i.test(text);
    if (!hasExplicitFirst || !hasExplicitGeneral) return formFields;

    return {
      ...formFields,
      openPreorderDate: '',
      openPreorderTime: '',
      preorderCloseDate: '',
      preorderCloseTime: '',
      membersOnlyDate: '',
      membersOnlyTime: '',
      earlyAccessDate: '',
      activeSubscribersTimeLocalRegional: '',
      earlyAccessDateTimeUKINT: '',
      earlyAccessDateTimeUSCanada: '',
    };
  };

  const hasAnyEventWindow = (formFields) => {
    const has = (v) => !!String(v || '').trim();
    if (has(formFields.openPreorderDate) && has(formFields.openPreorderTime)) return true;
    if (has(formFields.preorderCloseDate) && has(formFields.preorderCloseTime)) return true;
    if (has(formFields.membersOnlyDate) && has(formFields.membersOnlyTime)) return true;
    if (has(formFields.firstAccessDate) && (has(formFields.firstAccessTimeLocalRegional) || has(formFields.firstAccessTimeUKINT) || has(formFields.firstAccessTimeUSCanada))) return true;
    if (has(formFields.earlyAccessDate) && (has(formFields.activeSubscribersTimeLocalRegional) || has(formFields.earlyAccessDateTimeUKINT) || has(formFields.earlyAccessDateTimeUSCanada))) return true;
    if (has(formFields.publicAccessDate) && (has(formFields.publicAccessTimeLocalRegional) || has(formFields.publicAccessTimeUKINT) || has(formFields.publicAccessTimeUSCanada))) return true;
    return false;
  };

  // ─── Bulk analyze handler ──────────────────────────────────────────────────

  const handleBulkAnalyze = async () => {
    if (!csvFile) return;
    setBulkLoading(true);
    setBulkResults([]);
    setBulkProgress({ current: 0, total: 0 });

    let csvText = '';
    try {
      csvText = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsText(csvFile);
      });
    } catch (e) {
      setBulkResults([{ type: 'error', message: 'Failed to read CSV file' }]);
      setBulkLoading(false);
      return;
    }

    const rows = parseCSVText(csvText);
    if (rows.length === 0) {
      setBulkResults([{ type: 'error', message: 'No valid rows found in CSV' }]);
      setBulkLoading(false);
      return;
    }

    setBulkProgress({ current: 0, total: rows.length });
    const results = [];

    for (let i = 0; i < rows.length; i++) {
      const { bookboxName, text: rowText, link: rowLink, imgLink: rowImgLink } = rows[i];
      setBulkProgress({ current: i + 1, total: rows.length });

      const canonicalNames = bookBoxList.map((b) => b.name);
      const mappedName = matchCsvBookboxName(canonicalNames, bookboxName);
      const matchedBox = mappedName ? bookBoxList.find((b) => b.name === mappedName) : null;

      if (!matchedBox) {
        results.push({ type: 'error', message: `Row ${i + 1}: Bookbox name "${bookboxName}" is not in our list` });
        setBulkResults([...results]);
        continue;
      }

      if (!rowText.trim()) {
        results.push({ type: 'error', message: `Row ${i + 1} ("${bookboxName}"): Text column is empty, skipped` });
        setBulkResults([...results]);
        continue;
      }

      try {
        // Step 1 – analyze
        const analyzeResponse = await api.post('/analyze', { text: rowText, bookBox: matchedBox.name });
        const analyzedData = { ...analyzeResponse.data, bookBox: matchedBox.name };

        // Step 2 – convert to form-compatible payload
        let formFields = convertAnalyzeToFormData(analyzedData, rowLink, rowImgLink);
        formFields = remapSaleOnlyToOpenPreorder(formFields, rowText);
        formFields = enforceFirstAndGeneralOnlyWhenExplicit(formFields, rowText);

        if (!hasAnyEventWindow(formFields)) {
          results.push({
            type: 'error',
            message: `⚠ Row ${i + 1} ("${matchedBox.name}"): no valid date+time window extracted (nothing to create in calendar)`,
          });
          setBulkResults([...results]);
          continue;
        }

        // Step 3 – post to events API
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => formData.append(key, value || ''));
        const eventsResponse = await api.post('/events', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (!Array.isArray(eventsResponse.data) || eventsResponse.data.length === 0) {
          results.push({
            type: 'error',
            message: `⚠ Row ${i + 1} ("${matchedBox.name}"): API returned 0 events created`,
          });
          setBulkResults([...results]);
          continue;
        }

        results.push({
          type: 'success',
          message: `✅ Row ${i + 1}: "${matchedBox.name}"${formFields.bookName ? ` — ${formFields.bookName}` : ''}: saved ${eventsResponse.data.length} event(s) to calendar`,
        });
      } catch (err) {
        results.push({
          type: 'error',
          message: `❌ "${bookboxName}": ${err.response?.data?.message || err.message}`,
        });
      }

      setBulkResults([...results]);
      // Small delay to avoid rate-limiting
      if (i < rows.length - 1) await new Promise(r => setTimeout(r, 300));
    }

    setBulkLoading(false);
  };

  const handleAnalyze = async () => {
    if (!text.trim()) {
      setError('Please enter some text to analyze');
      return;
    }

    if (!selectedBookBox) {
      setError('Please select a Book Box');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/analyze', { text, bookBox: selectedBookBox });
      
      // Print the result from the prompt execution in browser console
      console.log('📋 Analysis Result from Prompt Execution:');
      console.log('═══════════════════════════════════════════════════════════════════');
      console.log(JSON.stringify(response.data, null, 2));
      console.log('═══════════════════════════════════════════════════════════════════');
      
      // Store analyzed data and original inputText
      localStorage.setItem('analyzedEvent', JSON.stringify(response.data));
      localStorage.setItem('inputText', text);
      navigate('/admin/form');
    } catch (err) {
      console.error('❌ Error analyzing text:', err);
      console.error('Error response:', err.response?.data);
      setError(err.response?.data?.message || 'Error analyzing text');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-analyze">
      <nav className="admin-nav">
        <div className="nav-container">
          <button 
            className={`nav-button ${location.pathname === '/admin/analyze' ? 'active' : ''}`}
            onClick={() => navigate('/admin/analyze')}
          >
            Analyze
          </button>
          <button 
            className={`nav-button ${location.pathname === '/admin/form' ? 'active' : ''}`}
            onClick={() => navigate('/admin/form')}
          >
            Form
          </button>
          <button 
            className={`nav-button ${location.pathname === '/' ? 'active' : ''}`}
            onClick={() => navigate('/')}
          >
            Calendar
          </button>
        </div>
      </nav>
      <h2>Analyze Event Text</h2>
      <div className="analyze-container">
        <div className="form-group">
          <label>Select Book Box (Reference):</label>
          <select 
            value={selectedBookBox} 
            onChange={(e) => setSelectedBookBox(e.target.value)}
            className="bookbox-dropdown"
          >
            <option value="">-- Select a Book Box --</option>
            {bookBoxList.map((box, index) => (
              <option 
                key={index} 
                value={box.name}
                style={{
                  backgroundColor: box.color,
                  color: getTextColor(box.color),
                  padding: '8px',
                  fontWeight: '500'
                }}
              >
                {box.name}
              </option>
            ))}
          </select>
          {selectedBookBox && (
            <div className="selected-bookbox-info">
              <span className="bookbox-name">{selectedBookBox}</span>
              <span 
                className="bookbox-color-indicator" 
                style={{ backgroundColor: bookBoxList.find(b => b.name === selectedBookBox)?.color }}
              ></span>
              <span className="bookbox-color-code">
                {bookBoxList.find(b => b.name === selectedBookBox)?.color}
              </span>
            </div>
          )}
        </div>
        <div className="form-group">
          <label>Paste event text here:</label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Example: Summer Music Festival, June 15-17, 2024, $50 per ticket. Join us for an amazing weekend of live music..."
            rows={15}
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button onClick={handleAnalyze} disabled={loading || !text.trim() || !selectedBookBox}>
          {loading ? 'Analyzing...' : 'Analyze'}
        </button>

        <hr style={{ margin: '32px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />

        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600' }}>Analyze Bulk</h3>

        <div className="form-group">
          <label>File (CSV):</label>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => { setCsvFile(e.target.files[0] || null); setBulkResults([]); setBulkProgress({ current: 0, total: 0 }); }}
            style={{ display: 'block', marginTop: '6px' }}
          />
          <div style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>
            Expected columns: <strong>Bookbox name</strong>, <strong>Text</strong>, <strong>LINK</strong>, <strong>IMG_LINK</strong>
          </div>
        </div>

        <button
          onClick={handleBulkAnalyze}
          disabled={bulkLoading || !csvFile}
          style={{ marginBottom: '16px' }}
        >
          {bulkLoading ? `Analyzing… (${bulkProgress.current}/${bulkProgress.total})` : 'Analyze Bulk'}
        </button>

        {bulkResults.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
            {bulkResults.map((r, i) => (
              <div
                key={i}
                style={{
                  color: r.type === 'error' ? '#d32f2f' : '#2e7d32',
                  fontSize: '14px',
                  padding: '4px 0',
                }}
              >
                {r.message}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminAnalyze;









